import React from "react";
import { INDUSTRIES } from "../../data/site";
export function IndustriesMarquee() {
  const items = [...INDUSTRIES, ...INDUSTRIES];
  return <section aria-label="Industries we build for" className="marquee overflow-hidden border-b border-line py-[clamp(1.5rem,2.5vw,2.75rem)]" data-id="element-174" data-mp="16117ij4bt0ac">
      <p className="sr-only" data-id="element-175" data-mp="1fzqgtni5pcez">Built for: {INDUSTRIES.join(", ")}</p>
      <div className="marquee-track flex w-max items-center" aria-hidden data-id="element-176" data-mp="1fxci94o9pi2o">
        {items.map((name, i) => <span key={i} className="flex items-center whitespace-nowrap font-display text-[clamp(1.5rem,1rem+2vw,3.5rem)] font-medium tracking-tight text-fg/80" data-id="element-177" data-mp="s7ic15ygerre" data-mpi={i}>
            {name}
            <span className="mx-[clamp(1.25rem,2.5vw,3.5rem)] h-2 w-2 rounded-full bg-accent" data-id="element-178" data-mp="114arfvsiu4ox" />
          </span>)}
      </div>
    </section>;
}